import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { Media } from "src/app/models/media";

import * as JsBarcode from "jsbarcode";
import { Library } from "src/app/models/library";
import { ApplicationPool } from "src/app/services/application.pool";
import { MediaService } from "src/app/main/services/media.service";

@Component({
  selector: "media-barcode",
  templateUrl: "./media-barcode.component.html",

  styleUrls: ["./media-barcode.component.scss"]
})
export class MediaBarcodeComponent implements OnInit {
  get Library(): Library {
    return this.dataPool.Library;
  }

  @ViewChild("barcode") barcode: ElementRef;

  @Input() public media: Media;

  constructor(
    private dataPool: ApplicationPool,
    private mediaService: MediaService
  ) {}

  ngOnInit(): void {}
  ngAfterViewInit(): void {
    if (this.media) {
      JsBarcode(this.barcode.nativeElement, this.media.id.toString(), {
        width: 2,
        height: 50,
        displayValue: false,
        font: "Arial",
        textPosition: "top",
        textMargin: 0,
        fontSize: 12,
        margin: 0
      });
    }
  }

  get Author() {
    return this.mediaService.getAuthorSignature(this.media);
  }

  get createDate() {
    if (this.dataPool.Library.configuration.printCreateDateOnMediaBarcode) {
      return (
        this.media.createDate.substring(5, 7) +
        "/" +
        this.media.createDate.substring(0, 4)
      );
    }
    return "";
  }
}
